import { Dropdown } from 'bootstrap';

import {
    mainMenuContainer,
    mainMenuExtraSpace,
    mainMenuItemsGap,
    NAVIGATION_ANIMATION_DURATION,
    SCREEN_WIDTH_TABLET,
} from '../constants';
import { addClass, getClosesParent, hasClass, removeClass } from './generic';
import { scrollToSelector } from './scroll';

export let manageMenuTimer: NodeJS.Timeout;

/**
 * Returns reference to the primary navigation element
 */
export const getNavbarCollapse = (): Element => {
    return document.getElementsByClassName('navbar-collapse')[0];
};

export const getNavbar = (): HTMLElement | null => {
    return mainMenuContainer ? mainMenuContainer.querySelector('.navbar') : null;
};

// sticky navigation
export const stickyNavigationToggle = (): void => {
    const scrollPosition = window.pageYOffset;
    const windowWidth = window.innerWidth;
    const navBar = getNavbar();

    manageMenuTimer && clearTimeout(manageMenuTimer);

    if (navBar) {
        if (windowWidth >= SCREEN_WIDTH_TABLET && scrollPosition > 0 && !hasClass(navBar, 'navbar--sticky')) {
            addClass(navBar, 'navbar--sticky');
        } else if ((windowWidth < SCREEN_WIDTH_TABLET || scrollPosition === 0) && hasClass(navBar, 'navbar--sticky')) {
            removeClass(navBar, 'navbar--sticky');
        }

        //manageMenuItems();
        manageMenuTimer = setTimeout(manageMenuItems, 300); // trochu prasecina, ale je to treba jeste po dokonceni animaci
    }
};

export const setToggleMenuPositionEvents = (): void => {
    // zjisteni velikosti panelu s navigaci + otevreneho menu a pokud je vetsi nez vyska screenu, zrusi fixni pozici
    // tim umozni scrollovani menu (jinak by dolni polozky byly nedostupne)
    const navBar = getNavbar();
    if (navBar) {
        navBar.addEventListener('shown.bs.collapse', toggleMenuPosition);
        navBar.addEventListener('hidden.bs.collapse', toggleMenuPosition);
        navBar.addEventListener('shown.bs.dropdown', toggleMenuPosition);
        navBar.addEventListener('hidden.bs.dropdown', toggleMenuPosition);
    }
};

const toggleMenuPosition = (e: MouseEvent): void => {
    const navBar = getNavbar();
    if (!navBar) {
        return;
    }

    const toggle = navBar.offsetHeight > window.innerHeight;
    if (toggle) {
        addClass(navBar, 'pos-relative');
    } else {
        removeClass(navBar, 'pos-relative');
    }

    if (toggle) {
        const target = e.relatedTarget ? e.relatedTarget : e.currentTarget;
        const elId = target && (target as HTMLElement).getAttribute('id');
        elId && scrollToSelector('#' + elId);
    }
};

// it manages menu items according to device width - wrapped items are moved to "stored-items" submenu
export const manageMenuItems = (): void => {
    if (mainMenuContainer) {
        const showMoreBtn = mainMenuContainer.querySelector('ul.main-menu li.nav-item--show-more') as HTMLElement;
        const showMoreBtnWidth = showMoreBtn?.clientWidth || 0;

        // remove event handler from all toggles:
        const oldToggles = mainMenuContainer.querySelectorAll(
            'ul.navbar-nav ul.dropdown-menu a.nav-item__dropdown-toggler',
        );
        if (oldToggles && oldToggles.length > 0) {
            for (let i = 0; i < oldToggles.length; i++) {
                oldToggles[i] && (oldToggles[i] as HTMLLinkElement).removeEventListener('click', toggleSubmenu);
            }
        }

        // move all stored items to default container
        const storedItems = mainMenuContainer.querySelectorAll('#stored-items-submenu > li');
        if (storedItems && storedItems.length > 0) {
            if (showMoreBtn) {
                addClass(showMoreBtn, 'invisible');
            }
            // hide show more button
            for (let i = 0; i < storedItems.length; i++) {
                const storedItem = storedItems[i];
                if (showMoreBtn) {
                    showMoreBtn.before(storedItem);
                }
                enableExpandableMenu(storedItem as HTMLElement);
            }
        }

        const windowWidth = window.innerWidth;
        if (windowWidth >= SCREEN_WIDTH_TABLET) {
            const menuWidth = Math.floor(
                (mainMenuContainer.querySelector('.navbar-collapse')?.clientWidth || 0) -
                    (mainMenuContainer.querySelector('ul.technical-menu')?.clientWidth || 0) -
                    showMoreBtnWidth -
                    mainMenuExtraSpace,
            );

            let usedWidth = 0;
            const defaultOffset = (mainMenuContainer.querySelector('ul.main-menu') as HTMLElement)?.offsetTop || 0;
            //const showMoreOffset = showMoreBtn.offsetTop;

            const items = mainMenuContainer.querySelectorAll('ul.main-menu > li.nav-item');
            for (let i = 0; i < items.length; i++) {
                const item = items[i] as HTMLElement;
                if (item.style.display !== 'none' && !hasClass(item, 'nav-item--show-more')) {
                    // odstraneni priznaku posledni polozky
                    removeClass(item, 'nav-item--last-generic');
                    usedWidth = usedWidth + Math.ceil(item.clientWidth) + mainMenuItemsGap;
                    const topOffset = item.offsetTop;
                    if (usedWidth > menuWidth || topOffset > defaultOffset) {
                        //disableExpandableMenu(item);
                        const target = mainMenuContainer.querySelector('#stored-items-submenu');
                        if (target) {
                            target.append(item);
                        }
                    }
                }
            }

            // oznaceni posledni standardni polozky v menu (kvuli zarovnani submenu doleva namisto doprava)
            //$('ul.main-menu > li.nav-item--generic').last().addClass('nav-item--last-generic');
            const lastItem = mainMenuContainer.querySelector('ul.main-menu > li.nav-item--generic:last-child');
            if (lastItem) {
                addClass(lastItem, 'nav-item--last-generic');
            }
        }

        // custom rozsireni Bootstrap menu o podporu rozklikavaciho menu v druhe urovni
        const newToggles = mainMenuContainer.querySelectorAll(
            'ul.navbar-nav ul.dropdown-menu a.nav-item__dropdown-toggler',
        );
        for (let i = 0; i < newToggles.length; i++) {
            newToggles[i] && (newToggles[i] as HTMLLinkElement).addEventListener('click', toggleSubmenu);
        }

        if (showMoreBtn) {
            const hiddenItems = mainMenuContainer.querySelectorAll('#stored-items-submenu > li');
            if (hiddenItems.length > 0) {
                //$('ul.main-menu').append($(showMoreBtn).detach());
                removeClass(showMoreBtn, 'invisible');
            } else {
                addClass(showMoreBtn, 'invisible');
            }
        }
    }
};

/**
 * Funkce, která ošetří interní přesměrování v menu na kotvu.
 * Pokud se detekuje, že odkaz v menu směřuje na stejnou stránku jako je aktuálně zobrazená a odkaz obsahuje parametrz
 * s kotvou, vygeneruje se v menu data atribut "data-scroll-target" s hodnotou kotvy. V takovém případě by se měla
 * zablokovat výchozí akce kliknutí na odkaz (přechod na danou/tutéž stránku) a rovnou by mělo dojít k přesměrování na
 * příslušnou kotvu.
 */
export const handleAnchorLinks = (): void => {
    const anchorLinks = document.querySelectorAll('.main-menu a.nav-item__link[data-scroll-target]');
    for (let i = 0; i < anchorLinks.length; i++) {
        anchorLinks[i].addEventListener('click', function (e) {
            const anchor = this.getAttribute('data-scroll-target'); // existuje definice cile?
            const target = anchor && document.querySelector(anchor);
            if (target) {
                // provede se pouze, pokud cíl skutečně existuje
                e.preventDefault();
                scrollToSelector(anchor);
            }
        });
    }
};

const toggleSubmenu = (e: MouseEvent): void => {
    e.preventDefault();
    e.stopPropagation(); // je treba zabranit collapsu na nadrazenem elementu

    if (mainMenuContainer) {
        const toggler = e.relatedTarget ? e.relatedTarget : e.currentTarget || (e as any).delegateTarget;
        const togglerId = toggler.getAttribute('id');
        const parentLi = toggler.parentElement;
        const parentUlId = parentLi.parentElement.getAttribute('id');

        // zavrit vsechna otevrena menu na stejne urovni
        const toggles = document.querySelectorAll(`#${parentUlId} > li > .nav-item__dropdown-toggler.show`);
        for (let i = 0; i < toggles.length; i++) {
            if (togglerId !== toggles[i].getAttribute('id')) {
                const expanded = toggles[i].getAttribute('aria-expanded');
                if (expanded) {
                    const bsDropdown = Dropdown.getOrCreateInstance(toggles[i]);
                    bsDropdown && bsDropdown.hide();
                }
            }
        }

        // zjisteni velikosti panelu s navigaci + otevreneho menu a pokud je vetsi nez vyska screenu, zrusi fixni pozici
        // tim umozni scrollovani menu (jinak by dolni polozky byly nedostupne)
        const navbarPanel = getNavbar();
        const openedMainDropdown = mainMenuContainer.querySelector(
            'ul.main-menu > li.nav-item > ul.nav-item__sub-nav.dropdown-menu.show',
        );
        if (navbarPanel) {
            const toggle =
                (openedMainDropdown as HTMLElement).offsetHeight + navbarPanel.offsetHeight > window.innerHeight;
            if (toggle) {
                addClass(navbarPanel, 'pos-relative');
                const elId = toggler.getAttribute('id');
                elId && scrollToSelector('#' + elId);
            } else {
                removeClass(navbarPanel, 'pos-relative');
            }
        }
    }
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const disableExpandableMenu = (menuItem: HTMLElement): void => {
    const toggler = menuItem.querySelector('.nav-item__dropdown-toggler');
    if (toggler) {
        toggler.removeAttribute('data-bs-toggle');
    }
};
const enableExpandableMenu = (menuItem: HTMLElement): void => {
    const toggler = menuItem.querySelector('.nav-item__dropdown-toggler');
    if (toggler) {
        toggler.setAttribute('data-bs-toggle', 'dropdown');
    }
};

/**
 * POZOR: Nefunguje to uplne idealne na vetsich zarizenich s dotykovou obrazovkou.
 * Potiz je v tom, ze se sice registruje mouseenter event pri touchi, ale menu se neotevre, je treba dalsi touch.
 * Mouseleave event je pak detekovan az v pripade, dojde k touchi nekde jinde.
 */
export const enableToggleMenuOnHover = (): void => {
    const mouseOutTimeout: Array<any> = [];

    if (mainMenuContainer) {
        if (window.innerWidth <= SCREEN_WIDTH_TABLET) {
            console.warn('ToggleMenuOnHover: Functionality is disabled for small screens');
            return; // do not active it for small screens
        }

        const dropdownItems = mainMenuContainer.querySelectorAll('.main-menu > li.dropdown');

        for (let i = 0; i < dropdownItems.length; i++) {
            const dropdownItem = dropdownItems[i] as HTMLElement;
            if (dropdownItem) {
                dropdownItem.addEventListener('mouseenter', (e: MouseEvent) => onMouseEnter(e, dropdownItem));
                dropdownItem.addEventListener('mouseleave', (e: MouseEvent) => onMouseLeave(e, dropdownItem));
            }
        }
    }

    function onMouseEnter(evt: MouseEvent, el: HTMLElement): void {
        const parentUl = getClosesParent(el as Node, function (el: HTMLElement) {
            return !!(el.tagName && el.tagName.toUpperCase() === 'UL');
        });
        // is it excluded because it's in special menu?
        const isExcluded = parentUl && hasClass(parentUl as HTMLUListElement, 'stored-items');

        if (!isExcluded) {
            const toggler =
                (parentUl as HTMLUListElement).querySelector(
                    `li#${el.getAttribute('id')} > .nav-item__dropdown-toggler`,
                ) ||
                (parentUl as HTMLUListElement).querySelector(`li#${el.getAttribute('id')} > .nav-item__more-toggler`);

            if (toggler) {
                const togglerId = toggler.getAttribute('id') as any;
                if (togglerId) {
                    clearInterval(mouseOutTimeout[togglerId]);
                }
                const expanded = toggler.getAttribute('aria-expanded');
                if (!expanded || expanded === 'false') {
                    // prepnout pouze, pokud je zavreny
                    const bsDropdown = Dropdown.getOrCreateInstance(toggler);
                    bsDropdown.toggle();
                }
                (toggler as HTMLElement).blur();
            }
        }
    }

    function onMouseLeave(evt: MouseEvent, el: HTMLElement): void {
        const parentUl = getClosesParent(el as Node, function (el: HTMLElement) {
            return !!(el.tagName && el.tagName.toUpperCase() === 'UL');
        });
        const toggler =
            (parentUl as HTMLUListElement).querySelector(`li#${el.getAttribute('id')} > .nav-item__dropdown-toggler`) ||
            (parentUl as HTMLUListElement).querySelector(`li#${el.getAttribute('id')} > .nav-item__more-toggler`);
        if (toggler) {
            const togglerId = toggler.getAttribute('id') as any;

            if (togglerId) {
                clearInterval(mouseOutTimeout[togglerId]);
                mouseOutTimeout[togglerId] = setTimeout(function () {
                    const expanded = toggler.getAttribute('aria-expanded');
                    if (expanded === 'true') {
                        // prepnout pouze, pokud je otevreny
                        const bsDropdown = Dropdown.getOrCreateInstance(toggler);
                        bsDropdown.toggle();
                    }
                }, NAVIGATION_ANIMATION_DURATION);
            }
        }
    }
};
